module.exports = __webpack_public_path__ + "img/delete_bin.baac2c07.svg";